import http from "../utils/http";

export const getBondDebtsClientsSumaaries = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/bond-debts/clients/summaries", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBondDeptsClientDetailList = (clientIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/bond-debts/clients/${clientIdx}/list`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const modifyClientBalance = (clientIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/clients/${clientIdx}/balance`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBondDeptsClientSummariesExcel = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/bond-debts/clients/summaries/excel`, body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const excelUploadModifyBalances = (file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/clients/balance/excel/files`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getClientsExcelFile = () => {
  return new Promise((resolve, reject) => {
    http
      .post(`/clients/list/excel`, {}, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBondDeptsClientDetailExcel = (clientIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/bond-debts/clients/${clientIdx}/excel`, body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
